var _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4768,
    height: 1462,
    viewBox: "0 0 4768 1462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1950.34 69.3235C2195.04 781.912 3308.78 847.851 3897.71 847.851H4700.14C4700.69 847.851 4701 848.285 4701 848.837V1460.15C4701 1460.7 4700.55 1461.09 4700 1461.09H3.99996C3.44768 1461.09 3 1460.65 3 1460.09V848.851C3 848.299 3.42376 847.851 3.97605 847.851C606.889 847.779 1703.88 781.527 1948.41 69.3241C1948.72 68.4204 1950.03 68.4197 1950.34 69.3235Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 845C1429.45 845 1824.24 406.106 1948.5 71C2072.95 406.106 2468.38 845 3831 845H4698.5",
    stroke: "url(#paint0_linear_2_109)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1948.5 91L1948.97 90.8239L1948.5 89.5792L1948.03 90.8242L1948.5 91ZM69 850.5C68.7239 850.5 68.5 850.724 68.5 851C68.5 851.276 68.7239 851.5 69 851.5V850.5ZM4668.5 851.5C4668.78 851.5 4669 851.276 4669 851C4669 850.724 4668.78 850.5 4668.5 850.5V851.5ZM3831 850.5C3149.73 850.5 2710.31 743.195 2425.67 594.59C2141.04 445.993 2011.15 256.09 1948.97 90.8239L1948.03 91.1761C2010.3 256.664 2140.35 446.761 2425.2 595.476C2710.04 744.182 3149.64 851.5 3831 851.5V850.5ZM69 851.5C749.272 851.5 1188.17 744.182 1472.56 595.476C1756.96 446.761 1886.8 256.664 1948.97 91.1758L1948.03 90.8242C1885.95 256.091 1756.27 445.993 1472.09 594.59C1187.9 743.195 749.18 850.5 69 850.5V851.5ZM3831 851.5H4668.5V850.5H3831V851.5Z",
    fill: "url(#paint1_linear_2_109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1948.5 106L1948.78 105.894L1948.5 105.148L1948.22 105.894L1948.5 106ZM69 854.7C68.8343 854.7 68.7 854.834 68.7 855C68.7 855.166 68.8343 855.3 69 855.3V854.7ZM4673.5 855.3C4673.67 855.3 4673.8 855.166 4673.8 855C4673.8 854.834 4673.67 854.7 4673.5 854.7V855.3ZM3831 854.7C3149.71 854.7 2710.26 750.134 2425.57 604.254C2140.9 458.379 2010.98 271.188 1948.78 105.894L1948.22 106.106C2010.47 271.535 2140.49 458.843 2425.3 604.788C2710.1 750.727 3149.66 855.3 3831 855.3V854.7ZM69 855.3C749.253 855.3 1188.12 750.727 1472.46 604.788C1756.82 458.843 1886.63 271.535 1948.78 106.106L1948.22 105.894C1886.12 271.188 1756.41 458.379 1472.19 604.254C1187.96 750.134 749.2 854.7 69 854.7V855.3ZM3831 855.3H4673.5V854.7H3831V855.3Z",
    fill: "url(#paint2_linear_2_109)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1952.74 238.089C1952.8 237.356 1953.87 237.356 1953.93 238.089L1981.25 562.004C1981.59 566.013 1982.63 569.929 1984.33 573.575L2079.98 778.603C2080.29 779.27 2079.36 779.803 2078.94 779.196L1963.22 610.995C1958.45 604.064 1948.22 604.064 1943.45 610.995L1827.73 779.196C1827.31 779.803 1826.38 779.27 1826.69 778.603L1922.34 573.575C1924.04 569.929 1925.08 566.013 1925.42 562.004L1952.74 238.089Z",
    fill: "url(#paint3_linear_2_109)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1925.85 556.627L1932.25 480.985C1932.34 479.896 1933.87 479.723 1934.2 480.764L1984.94 639.081C1985.29 640.177 1983.82 640.901 1983.17 639.955L1926.03 557.28C1925.9 557.089 1925.83 556.858 1925.85 556.627Z",
    fill: "#282A32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1901.1 744.35C1853.84 880.192 1782.43 1066.57 1486.27 1183.38",
    stroke: "url(#paint4_linear_2_109)",
    strokeWidth: 0.864226
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1770.75,
    y: 701.686,
    width: 15.6227,
    height: 1,
    rx: 0.5,
    transform: "rotate(135 1770.75 701.686)",
    fill: "url(#paint5_linear_2_109)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.6227,
    height: 1.11282,
    rx: 0.556412,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 2141.62 704.686)",
    fill: "url(#paint6_linear_2_109)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.07217,
    height: 1,
    rx: 0.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1741.05 731.389)",
    fill: "url(#paint7_linear_2_109)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.25183,
    height: 1,
    rx: 0.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 1734.13 738.309)",
    fill: "url(#paint8_linear_2_109)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2171.32,
    y: 734.389,
    width: 9.07217,
    height: 1.11282,
    rx: 0.556412,
    transform: "rotate(-135 2171.32 734.389)",
    fill: "url(#paint9_linear_2_109)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2176.88,
    y: 739.941,
    width: 1.32728,
    height: 1.11282,
    rx: 0.556412,
    transform: "rotate(-135 2176.88 739.941)",
    fill: "url(#paint10_linear_2_109)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2127.83 690.813L2033.35 596.34C2021.21 584.191 2013.31 568.443 2010.84 551.441L1974.56 301.74",
    stroke: "url(#paint11_linear_2_109)",
    strokeWidth: 1.11282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.2 690.813L1875.67 596.34C1887.82 584.191 1895.72 568.443 1898.19 551.441L1934.47 301.74",
    stroke: "url(#paint12_linear_2_109)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1882.59 464.443L1901.46 358.332",
    stroke: "url(#paint13_linear_2_109)",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2040.58 546.975L2026.43 462.086",
    stroke: "url(#paint14_linear_2_109)",
    strokeWidth: 0.864226,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2012.28 403.135L2007.57 370.123",
    stroke: "url(#paint15_linear_2_109)",
    strokeWidth: 0.864226,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1922.68 264.011L1925.04 249.863",
    stroke: "url(#paint16_linear_2_109)",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1985 700C2027.24 809.369 2140.56 1003.34 2324.64 1101",
    stroke: "url(#paint17_linear_2_109)",
    strokeWidth: 0.864226
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1827.08 1105.81C1792.01 1168.53 1749.72 1215.34 1715 1251.65",
    stroke: "url(#paint18_linear_2_109)",
    strokeWidth: 0.864226
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2105.03 608.343C2135.87 643.694 2147.4 654.885 2167.72 672.418",
    stroke: "url(#paint19_linear_2_109)",
    strokeWidth: 0.864226
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2178 1109C2209.59 1164.37 2294.34 1262.56 2432 1312",
    stroke: "url(#paint20_linear_2_109)",
    strokeWidth: 0.864226
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2003.33 104.371C2081 284 2276.14 459.695 2438.22 542.201",
    stroke: "url(#paint21_linear_2_109)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1885.47 104.371C1822 285 1612.66 459.695 1450.57 542.201",
    stroke: "url(#paint22_linear_2_109)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3180.38 775.495C3180.57 775.579 3180.72 775.697 3180.85 775.819C3180.98 775.954 3181.09 776.124 3181.18 776.306C3181.24 776.491 3181.31 776.685 3181.32 776.93C3181.35 777.169 3181.33 777.432 3181.27 777.728L3181.2 778.179C3180.96 779.608 3180.13 780.193 3178.68 779.957L3173.84 779.131C3173.84 779.131 3174.22 776.914 3174.59 774.704C3174.98 772.487 3175.35 770.276 3175.35 770.276L3179.93 771.051C3181.37 771.292 3181.96 772.138 3181.71 773.574L3181.68 773.743C3181.6 774.236 3181.46 774.63 3181.24 774.914C3181.04 775.207 3180.76 775.392 3180.38 775.495ZM3175.74 775.487L3175.29 778.098L3178.86 778.707C3179.2 778.765 3179.46 778.736 3179.62 778.589C3179.79 778.471 3179.92 778.234 3179.97 777.895L3180.09 777.205C3180.15 776.875 3180.11 776.613 3179.99 776.442C3179.87 776.264 3179.64 776.153 3179.3 776.087L3175.74 775.487ZM3176.38 771.735L3175.95 774.241L3179.35 774.831C3179.66 774.872 3179.89 774.818 3180.05 774.685C3180.2 774.558 3180.31 774.333 3180.37 774.002L3180.47 773.432C3180.52 773.093 3180.49 772.832 3180.37 772.648C3180.24 772.468 3180.02 772.351 3179.69 772.294L3176.38 771.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3183.84 771.718L3185.11 771.92C3185.11 771.92 3184.8 773.829 3184.48 775.716C3184.16 777.625 3183.85 779.527 3183.85 779.527L3188.92 780.348C3188.92 780.348 3189.24 778.454 3189.55 776.552C3189.85 774.663 3190.17 772.754 3190.17 772.754L3191.43 772.962C3191.43 772.962 3191.12 774.865 3190.81 776.76C3190.5 778.662 3190.2 780.565 3190.2 780.565C3190.16 780.741 3190.11 780.892 3190.01 781.047C3189.92 781.188 3189.82 781.305 3189.68 781.398C3189.55 781.498 3189.39 781.568 3189.23 781.6C3189.06 781.646 3188.9 781.658 3188.72 781.616L3183.64 780.787C3183.46 780.754 3183.31 780.701 3183.15 780.599C3183.02 780.52 3182.89 780.398 3182.8 780.266C3182.7 780.134 3182.64 779.984 3182.59 779.828C3182.56 779.653 3182.54 779.479 3182.58 779.303C3182.58 779.303 3182.9 777.409 3183.22 775.508C3183.52 773.612 3183.84 771.718 3183.84 771.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3194.59 773.477C3194.59 773.477 3194.24 775.69 3193.88 777.91C3193.53 780.123 3193.17 782.343 3193.17 782.343L3191.9 782.133C3191.9 782.133 3192.26 779.921 3192.62 777.701C3192.98 775.481 3193.33 773.276 3193.33 773.276L3194.59 773.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3197.76 773.977C3197.76 773.977 3197.46 775.874 3197.15 777.776C3196.85 779.68 3196.56 781.583 3196.56 781.583L3201.13 782.301L3200.92 783.562C3200.92 783.562 3199.47 783.34 3198 783.109C3196.54 782.872 3195.09 782.643 3195.09 782.643C3195.09 782.643 3195.43 780.429 3195.78 778.216C3196.14 775.989 3196.49 773.775 3196.49 773.775L3197.76 773.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3201.16 774.517C3201.16 774.517 3202.94 774.788 3204.71 775.066C3206.49 775.337 3208.26 775.601 3208.26 775.601L3208.07 776.871L3205.14 776.432C3205.14 776.432 3204.86 778.337 3204.57 780.234C3204.28 782.131 3203.98 784.043 3203.98 784.043L3202.71 783.848C3202.71 783.848 3203 781.944 3203.3 780.039C3203.6 778.143 3203.89 776.232 3203.89 776.232L3200.97 775.787L3201.16 774.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3219.32 785.021C3219.29 785.197 3219.23 785.363 3219.15 785.512C3219.06 785.653 3218.95 785.77 3218.81 785.877C3218.68 785.977 3218.53 786.04 3218.37 786.086C3218.2 786.126 3218.03 786.136 3217.86 786.118L3212.76 785.358C3212.58 785.332 3212.43 785.286 3212.28 785.184C3212.14 785.112 3212.02 784.998 3211.92 784.866C3211.82 784.726 3211.74 784.574 3211.7 784.419C3211.66 784.242 3211.66 784.084 3211.68 783.9C3211.68 783.9 3211.92 782.32 3212.16 780.733C3212.39 779.152 3212.63 777.557 3212.63 777.557C3212.65 777.394 3212.71 777.23 3212.79 777.095C3212.88 776.939 3212.99 776.823 3213.13 776.723C3213.27 776.63 3213.4 776.551 3213.57 776.512C3213.74 776.466 3213.9 776.455 3214.08 776.482L3219.15 777.224C3219.33 777.25 3219.49 777.303 3219.61 777.403C3219.77 777.491 3219.89 777.597 3219.99 777.731C3220.09 777.863 3220.16 778.014 3220.2 778.176C3220.25 778.346 3220.25 778.512 3220.24 778.682C3220.24 778.682 3220 780.262 3219.78 781.851C3219.54 783.432 3219.32 785.021 3219.32 785.021ZM3213.89 777.751C3213.89 777.751 3213.65 779.339 3213.42 780.927C3213.18 782.507 3212.95 784.088 3212.95 784.088L3218.05 784.848C3218.05 784.848 3218.28 783.252 3218.51 781.671C3218.74 780.082 3218.97 778.487 3218.97 778.487L3213.89 777.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3222.33 786.759L3221.05 786.563C3221.05 786.563 3221.36 784.345 3221.68 782.122C3222 779.898 3222.31 777.681 3222.31 777.681L3223.59 777.862C3223.59 777.862 3224.68 779.773 3225.78 781.676C3226.86 783.593 3227.97 785.513 3227.97 785.513C3227.97 785.513 3228.21 783.782 3228.45 782.051C3228.69 780.335 3228.91 778.603 3228.91 778.603L3230.19 778.791C3230.19 778.791 3229.88 781.016 3229.57 783.234C3229.27 785.46 3228.96 787.678 3228.96 787.678L3227.69 787.511C3227.69 787.511 3226.58 785.592 3225.49 783.682C3224.4 781.771 3223.31 779.854 3223.31 779.854C3223.31 779.854 3223.06 781.583 3222.82 783.306C3222.57 785.029 3222.33 786.759 3222.33 786.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3239.46 780.045C3239.46 780.045 3240.02 782.378 3240.59 784.727C3241.15 787.061 3241.72 789.402 3241.72 789.402L3240.43 789.234L3239.93 787.072L3235.89 786.535L3234.83 788.485L3233.55 788.317C3233.55 788.317 3234.71 786.206 3235.86 784.087C3237.02 781.975 3238.18 779.871 3238.18 779.871L3239.46 780.045ZM3236.55 785.33L3239.6 785.739L3238.6 781.623L3236.55 785.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3244.15 789.716L3242.87 789.542C3242.87 789.542 3243.15 787.314 3243.45 785.087C3243.74 782.874 3244.02 780.646 3244.02 780.646L3245.3 780.806C3245.3 780.806 3246.41 782.704 3247.53 784.597C3248.65 786.496 3249.77 788.395 3249.77 788.395C3249.77 788.395 3249.99 786.669 3250.21 784.937C3250.43 783.219 3250.64 781.492 3250.64 781.492L3251.92 781.652C3251.92 781.652 3251.64 783.879 3251.35 786.107C3251.08 788.336 3250.8 790.565 3250.8 790.565L3249.52 790.39C3249.52 790.39 3248.4 788.498 3247.27 786.605C3246.15 784.706 3245.04 782.8 3245.04 782.8C3245.04 782.8 3244.82 784.533 3244.6 786.258C3244.37 787.983 3244.15 789.716 3244.15 789.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3257.42 790.082C3258.01 790.147 3258.49 790.048 3258.84 789.763C3259.2 789.486 3259.42 789.052 3259.49 788.457L3259.81 785.782C3259.85 785.492 3259.83 785.232 3259.78 784.982C3259.73 784.747 3259.62 784.535 3259.48 784.369C3259.35 784.19 3259.17 784.041 3258.94 783.931C3258.73 783.822 3258.48 783.744 3258.19 783.713L3254.92 783.31C3254.92 783.31 3254.74 784.903 3254.54 786.501C3254.34 788.093 3254.15 789.679 3254.15 789.679L3257.42 790.082ZM3252.71 790.792C3252.71 790.792 3252.99 788.564 3253.26 786.335C3253.53 784.113 3253.82 781.885 3253.82 781.885L3258.35 782.432C3258.82 782.491 3259.23 782.614 3259.6 782.819C3259.97 783.009 3260.26 783.257 3260.51 783.563C3260.74 783.868 3260.92 784.217 3261.01 784.621C3261.11 785.019 3261.14 785.46 3261.09 785.92L3260.77 788.602C3260.71 789.076 3260.59 789.508 3260.39 789.866C3260.2 790.24 3259.95 790.536 3259.64 790.781C3259.35 791.015 3258.98 791.191 3258.58 791.298C3258.18 791.384 3257.74 791.415 3257.27 791.357L3252.71 790.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3266.54 783.406C3266.54 783.406 3268.17 783.59 3269.79 783.786C3271.41 783.968 3273.04 784.145 3273.04 784.145L3272.9 785.427L3267.67 784.826L3267.38 787.376L3271.84 787.879L3271.69 789.168L3267.24 788.665L3266.79 792.474L3265.51 792.329C3265.51 792.329 3265.77 790.105 3266.03 787.868C3266.29 785.637 3266.54 783.406 3266.54 783.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3281.27 792.786C3281.25 792.969 3281.2 793.129 3281.12 793.285C3281.03 793.427 3280.92 793.551 3280.79 793.659C3280.67 793.754 3280.52 793.83 3280.35 793.876C3280.19 793.93 3280.02 793.947 3279.85 793.923L3274.74 793.369C3274.56 793.35 3274.4 793.311 3274.24 793.222C3274.1 793.143 3273.98 793.029 3273.86 792.909C3273.77 792.77 3273.69 792.632 3273.64 792.476C3273.59 792.306 3273.58 792.133 3273.58 791.961C3273.58 791.961 3273.77 790.361 3273.95 788.774C3274.13 787.18 3274.29 785.577 3274.29 785.577C3274.32 785.409 3274.37 785.257 3274.46 785.101C3274.54 784.952 3274.65 784.835 3274.77 784.726C3274.91 784.619 3275.05 784.542 3275.21 784.494C3275.38 784.441 3275.55 784.43 3275.72 784.442L3280.81 785C3280.97 785.01 3281.14 785.071 3281.29 785.159C3281.44 785.24 3281.57 785.34 3281.66 785.479C3281.76 785.598 3281.85 785.743 3281.9 785.914C3281.94 786.075 3281.97 786.236 3281.95 786.406C3281.95 786.406 3281.78 788.008 3281.6 789.602C3281.44 791.198 3281.27 792.786 3281.27 792.786ZM3275.58 785.717C3275.58 785.717 3275.41 787.311 3275.23 788.912C3275.05 790.507 3274.87 792.101 3274.87 792.101L3279.99 792.647C3279.99 792.647 3280.15 791.051 3280.34 789.458C3280.5 787.87 3280.67 786.268 3280.67 786.268L3275.58 785.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290.72 789.255C3290.6 790.511 3289.98 791.161 3288.9 791.223L3290.22 795.001L3288.8 794.863L3287.51 791.13L3284.7 790.827L3284.33 794.407L3283.05 794.276C3283.05 794.276 3283.29 792.036 3283.51 789.808C3283.74 787.568 3283.99 785.344 3283.99 785.344L3288.88 785.851C3290.32 785.985 3290.97 786.787 3290.82 788.241L3290.72 789.255ZM3284.84 789.558L3288.39 789.927C3288.73 789.957 3288.98 789.899 3289.15 789.78C3289.31 789.648 3289.41 789.407 3289.45 789.067L3289.54 788.181C3289.57 787.833 3289.52 787.584 3289.39 787.419C3289.25 787.246 3289 787.148 3288.68 787.112L3285.13 786.743L3284.84 789.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3322.13 785.103C3322.13 785.103 3322.05 785.956 3321.95 787.243C3321.84 788.521 3321.7 790.234 3321.56 791.947C3321.42 793.653 3321.28 795.365 3321.17 796.644C3321.07 797.93 3321 798.79 3321 798.79L3318.21 798.56C3318.21 798.56 3318.28 797.701 3318.39 796.415C3318.49 795.135 3318.64 793.423 3318.79 791.711C3318.93 789.999 3319.06 788.285 3319.18 787.007C3319.29 785.722 3319.36 784.876 3319.36 784.876L3322.13 785.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3333.05 790.444C3333.05 790.444 3332.87 792.755 3332.7 795.067C3332.52 797.385 3332.35 799.696 3332.35 799.696C3332.24 801.132 3331.58 802.245 3330.62 802.973C3329.66 803.708 3328.39 804.051 3327.03 803.939C3325.7 803.838 3324.58 803.337 3323.78 802.57C3323 801.804 3322.54 800.764 3322.54 799.603L3325.3 799.852C3325.33 800.83 3326.17 801.344 3327.31 801.432C3328.39 801.505 3329.44 801.016 3329.56 799.509L3329.64 798.335C3328.9 798.743 3327.97 798.943 3326.95 798.854C3325.69 798.761 3324.58 798.154 3323.83 797.269C3323.07 796.398 3322.65 795.241 3322.75 794.062C3322.86 792.683 3323.45 791.571 3324.34 790.829C3325.23 790.094 3326.41 789.712 3327.66 789.811C3328.67 789.899 3329.56 790.239 3330.23 790.742L3330.27 790.251L3333.05 790.444ZM3329.85 795.683L3330.02 793.429C3329.52 792.551 3328.77 792.211 3327.99 792.148C3326.62 792.043 3325.61 792.888 3325.49 794.28C3325.41 795.318 3326.28 796.495 3327.63 796.612C3328.41 796.683 3329.23 796.463 3329.85 795.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3343.78 795.763C3343.68 797.187 3343.07 798.368 3342.13 799.17C3341.19 799.972 3339.93 800.387 3338.51 800.284C3337.1 800.181 3335.89 799.585 3335.08 798.665C3334.27 797.738 3333.83 796.479 3333.94 795.05C3334.05 793.635 3334.66 792.446 3335.6 791.638C3336.53 790.835 3337.8 790.413 3339.21 790.516C3340.62 790.611 3341.8 791.212 3342.62 792.146C3343.43 793.08 3343.88 794.34 3343.78 795.763ZM3341.09 795.566C3341.19 794.222 3340.39 793.081 3339.04 792.978C3337.67 792.88 3336.72 793.903 3336.61 795.246C3336.52 796.627 3337.32 797.718 3338.69 797.823C3340.05 797.891 3340.99 796.946 3341.09 795.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3361.3 792.347C3361.3 792.347 3361.16 794.655 3361.03 796.964C3360.89 799.265 3360.76 801.566 3360.76 801.566L3358.02 801.414L3358.05 800.907C3357.32 801.316 3356.38 801.558 3355.36 801.498C3354.1 801.419 3352.99 800.805 3352.22 799.882C3351.44 798.952 3351.02 797.716 3351.1 796.384C3351.19 795.039 3351.77 793.861 3352.66 793.039C3353.53 792.217 3354.7 791.741 3355.97 791.828C3356.97 791.886 3357.87 792.234 3358.54 792.73L3358.57 792.217L3361.3 792.347ZM3358.19 798.227L3358.36 795.399C3357.83 794.553 3357.05 794.268 3356.26 794.218C3354.87 794.14 3353.82 795.201 3353.74 796.555C3353.66 797.873 3354.57 799.061 3355.95 799.138C3356.75 799.19 3357.57 799.012 3358.19 798.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3372.24 797.194L3371.98 802.199L3369.3 802.066L3369.54 797.39C3369.62 795.871 3368.93 795.058 3367.6 794.985C3366.91 794.939 3366.11 795.297 3365.41 796.032C3365.41 796.032 3365.33 797.472 3365.25 798.933C3365.18 800.38 3365.09 801.834 3365.09 801.834L3362.33 801.671C3362.33 801.671 3362.47 799.37 3362.6 797.076C3362.74 794.768 3362.86 792.458 3362.86 792.458L3365.61 792.626L3365.56 793.31C3366.33 792.748 3367.23 792.486 3368.25 792.539C3369.47 792.6 3370.5 793.091 3371.21 793.899C3371.92 794.707 3372.31 795.84 3372.24 797.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3316.93 798.422L3314.12 798.182C3314.12 798.182 3313.79 796.433 3313.48 794.672C3313.18 792.918 3312.87 791.171 3312.87 791.171C3312.87 791.171 3311.73 792.79 3310.58 794.423C3309.45 796.049 3308.31 797.668 3308.31 797.668L3305.13 797.382C3305.13 797.382 3305.58 796.756 3306.25 795.817C3306.9 794.863 3307.78 793.61 3308.67 792.359C3309.55 791.092 3310.43 789.831 3311.08 788.884C3311.75 787.946 3312.19 787.319 3312.19 787.319L3311.54 783.506C3311.54 783.506 3310.94 784.366 3310.06 785.64C3309.16 786.912 3307.98 788.613 3306.79 790.313C3305.6 792.005 3304.41 793.704 3303.51 794.976C3302.62 796.249 3302.01 797.101 3302.01 797.101L3298.86 796.789C3298.86 796.789 3299.61 795.723 3300.75 794.119C3301.33 793.313 3301.99 792.367 3302.7 791.354C3303.41 790.355 3304.16 789.283 3304.92 788.203C3305.67 787.13 3306.43 786.05 3307.13 785.044C3307.84 784.037 3308.5 783.091 3309.06 782.284C3310.19 780.671 3310.94 779.605 3310.94 779.605L3313.69 779.853L3314.49 784.47L3317.32 784.705L3315.1 787.942C3315.1 787.942 3315.55 790.565 3316.01 793.189C3316.47 795.812 3316.93 798.422 3316.93 798.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3383.71 789.029C3383.71 789.029 3383.68 789.885 3383.61 791.169C3383.55 792.453 3383.49 794.174 3383.4 795.885C3383.32 797.605 3383.25 799.318 3383.18 800.601C3383.13 801.886 3383.1 802.742 3383.1 802.742L3380.3 802.619L3380.33 802.106C3379.59 802.521 3378.67 802.772 3377.65 802.727C3376.38 802.661 3375.25 802.059 3374.47 801.142C3373.69 800.226 3373.24 798.988 3373.31 797.647C3373.38 796.314 3373.95 795.135 3374.82 794.297C3375.68 793.466 3376.85 792.99 3378.12 793.041C3379.13 793.1 3380.03 793.419 3380.71 793.923L3380.95 788.894L3383.71 789.029ZM3380.45 799.416L3380.59 796.584C3380.06 795.724 3379.24 795.456 3378.44 795.42C3377.04 795.355 3376.01 796.427 3375.95 797.782C3375.88 799.137 3376.8 800.319 3378.2 800.385C3379 800.421 3379.82 800.237 3380.45 799.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3350.73 794.058C3350.12 794.085 3348.71 794.075 3347.8 795.159L3347.42 800.761L3344.67 800.572C3344.67 800.572 3344.82 798.279 3344.98 795.981C3345.14 793.682 3345.29 791.376 3345.29 791.376L3348.03 791.572L3347.99 792.262C3348.65 791.76 3349.6 791.498 3350.88 791.707",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_109",
    x: 0,
    y: 0.377029,
    width: 4767.5,
    height: 917.623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_109",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_109",
    x1: 2302.78,
    y1: 33.4203,
    x2: 2316.02,
    y2: -144.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_109",
    x1: 1594.79,
    y1: 49.9603,
    x2: 1581.87,
    y2: -125.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_109",
    x1: 1594.79,
    y1: 54.0369,
    x2: 1581.87,
    y2: -121.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_109",
    x1: 2150.44,
    y1: 999.633,
    x2: 1747.08,
    y2: 414.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_109",
    x1: 1901.1,
    y1: 759.443,
    x2: 1699.61,
    y2: 1238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251326,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_109",
    x1: 1778.56,
    y1: 701.686,
    x2: 1778.56,
    y2: 702.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_109",
    x1: 7.81134,
    y1: 0,
    x2: 7.81134,
    y2: 1.11282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_109",
    x1: 4.53609,
    y1: 0,
    x2: 4.53609,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_109",
    x1: 1.12592,
    y1: 0,
    x2: 1.12592,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_109",
    x1: 2175.86,
    y1: 734.389,
    x2: 2175.86,
    y2: 735.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_109",
    x1: 2177.54,
    y1: 739.941,
    x2: 2177.54,
    y2: 741.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_109",
    x1: 2074.77,
    y1: 301.74,
    x2: 2074.77,
    y2: 690.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_109",
    x1: 1870.8,
    y1: 311.172,
    x2: 1834.26,
    y2: 690.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_109",
    x1: 1847.22,
    y1: 311.172,
    x2: 1810.67,
    y2: 690.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_109",
    x1: 2075.95,
    y1: 393.703,
    x2: 2112.5,
    y2: 773.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_109",
    x1: 2057.09,
    y1: 294.667,
    x2: 2093.64,
    y2: 674.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_109",
    x1: 1882.59,
    y1: 150.827,
    x2: 1846.05,
    y2: 530.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_109",
    x1: 1985,
    y1: 700,
    x2: 2355.35,
    y2: 1053.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_109",
    x1: 1826.25,
    y1: 1105.56,
    x2: 1750.82,
    y2: 1267.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48081,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_109",
    x1: 2104.44,
    y1: 609.329,
    x2: 2146.71,
    y2: 679.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337869,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_109",
    x1: 2178,
    y1: 1109,
    x2: 2355.05,
    y2: 1358.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_109",
    x1: 2003.33,
    y1: 104.371,
    x2: 2477.22,
    y2: 497.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_109",
    x1: 1885.47,
    y1: 104.371,
    x2: 1411.58,
    y2: 497.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5923276bb1d29d0bfccc5f70c5757f9b.svg";
export { ForwardRef as ReactComponent };